import { DeliveryItem } from "@omni/components/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/deliveryItem";
import { Delivery } from "@omni/components/components/Product/ECommerce/components/delivery/delivery";
import { useECommerceProduct } from "@omni/components/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { useSingleStoreCheck } from "@omni/components/utils/hooks/store/useSingleStoreCheck.hook";
import { getTagIdFor } from "@omni/components/utils/tagging/tag.utils";
import { ProductVisibilityType } from "@omni/types/api/product/bff/shared/enums/productVisibilityType.enum";
import { cn } from "@omni/utils/styles";

import { OrderButton } from "@/components/Product/ECommerce/components/orderButton/orderButton.container";

export const DeliveryComponent = () => {
    const { isWebOnly, hasDelivery, visibilityType } = useECommerceProduct();
    const singleStoreCode = useSingleStoreCheck();

    const onlyHomeDelivery = visibilityType === ProductVisibilityType.Delivery;
    const onlyAvailableInStore =
        visibilityType === ProductVisibilityType.OnlyAvailableInStore;

    return (
        <>
            <Delivery.NoDelivery className={cn("tw:rounded-xl")} />
            {onlyAvailableInStore && !isWebOnly && (
                <Delivery.OnlyAvailableInStore displayEcommerceText={true} />
            )}
            {hasDelivery && !onlyAvailableInStore && (
                <>
                    <div className={cn("tw:flex tw:flex-col tw:gap-4")}>
                        <Delivery.Types
                            className={cn("tw:flex tw:flex-col tw:gap-4")}
                        >
                            <Delivery.Types.DeliveryItem
                                className={cn(
                                    "tw:p-4 tw:bg-grey tw:rounded-xl"
                                )}
                            >
                                <DeliveryItem.Info
                                    className={cn("tw:flex tw:justify-between")}
                                >
                                    <DeliveryItem.Info.DeliveryCost />
                                </DeliveryItem.Info>
                                <DeliveryItem.HomeDelivery>
                                    <DeliveryItem.HomeDelivery.DeliveryPromise />
                                    <DeliveryItem.HomeDelivery.MinimumOrderQuantity />
                                    <DeliveryItem.HomeDelivery.SupplierInfoLink />
                                </DeliveryItem.HomeDelivery>
                                <DeliveryItem.ClickAndCollect>
                                    <DeliveryItem.ClickAndCollect.LimitedStock />
                                    <DeliveryItem.ClickAndCollect.BoxPromise />
                                    <DeliveryItem.ClickAndCollect.NoStore />
                                    <DeliveryItem.ClickAndCollect.ItemStock />
                                    <DeliveryItem.ClickAndCollect.StorePickerButton
                                        hide={singleStoreCode !== undefined}
                                    />
                                </DeliveryItem.ClickAndCollect>
                                <DeliveryItem.AdditionalServices>
                                    <DeliveryItem.AdditionalServices.Item />
                                </DeliveryItem.AdditionalServices>
                            </Delivery.Types.DeliveryItem>
                        </Delivery.Types>
                        <Delivery.ProductConfiguration
                            className={cn(
                                "tw:my-0 tw:p-4 tw:border tw:border-grey-light tw:rounded-xl"
                            )}
                        />
                        <div
                            className={cn(
                                "tw:flex tw:justify-between tw:gap-4"
                            )}
                        >
                            <Delivery.Amount
                                className={cn("tw:[&>input]:p-0")}
                            />
                            <OrderButton
                                {...getTagIdFor("ecommerce-order-button")}
                            />
                        </div>
                    </div>
                    {onlyHomeDelivery && !isWebOnly && (
                        <Delivery.OnlyAvailableInStore
                            displayEcommerceText={false}
                        />
                    )}
                </>
            )}
        </>
    );
};
